import { FC, ReactNode } from 'react';

export const ContextMenuItem: FC<{
  icon?: ReactNode;
  label: string;
  labelClassName?: string;
}> = ({ icon, label, labelClassName }) => {
  return (
    <div className="flex items-center gap-2 w-full cursor-pointer">
      {icon ?? ''}
      <span className={`text-sm ${labelClassName ?? ''}`}>{label}</span>
    </div>
  );
};
